<div class="designations-grid-container">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-state">
    <mat-progress-spinner
      diameter="80"
      mode="indeterminate"
      color="primary">
    </mat-progress-spinner>
    <p class="loading-text">Loading designations...</p>
  </div>

  <!-- Grid State -->
  <lib-cdw-search-grid
    [class.hidden]="isLoading"
    class="ag-theme-balham"
    [columnDefs]="columnDefs"
    [itemLabel]="itemLabel"
    [searchGridDataSource]="'sql'"
    (rowClicked)="onRowClicked($event)"
    (cellClicked)="onCellClicked($event)"
    [filterBarSettings]="filterBarSettings"
    [cdwSearchGridDataService]="designationsDataService"
    [componentId]="designationsSearchComponentId"
    (deleteRowClicked)="deleteDesignationClicked($event)"
    (dataLoaded)="onDataLoaded()"
    [useMatIcon]="true"
    customHeaderFontWeight="700"
    customFirstColumnFontWeight="700"
    customRowFontWeight="700"
    [filterBySelectedColumnName]="filterBySelectedColumnName"
    [rowHeight]="36"
    #designationsGrid
  ></lib-cdw-search-grid>

  <!-- Show overlay when no designations exist -->
  <lib-cdw-empty-state-overlay
    *ngIf="showEmptyState"
    [htmlContent]="designationsEmptyStateHtml"
  ></lib-cdw-empty-state-overlay>
</div>
